import { render, staticRenderFns } from "./DepositOrderDetails.vue?vue&type=template&id=ef68a65a&scoped=true"
import script from "./DepositOrderDetails.vue?vue&type=script&lang=js"
export * from "./DepositOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./DepositOrderDetails.vue?vue&type=style&index=0&id=ef68a65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68a65a",
  null
  
)

export default component.exports